export enum ProviderStatus {
    APPROVED = 0,
    INACTIVE = 1,
    FINISHED = 2
}
